/** The slash commands Zot understands, with the short purpose shown in the menu. */
export const ZOT_SLASH_COMMANDS = [
  { command: "/room", purpose: "Brainstorm a feature with a simulated team" },
  { command: "/studio", purpose: "Workflows, skills, and tools" },
  { command: "/run", purpose: "Start, check, retry, or explain runs" },
  { command: "/work", purpose: "Work items and the backlog" },
  { command: "/approvals", purpose: "Summarise decisions; you decide" },
  { command: "/usage", purpose: "Spend, forecast, caps, and credits" },
  { command: "/automation", purpose: "Schedules and triggers" },
  { command: "/integrations", purpose: "Connection health and access" },
  { command: "/market", purpose: "Reviewed packs to install" },
  { command: "/evidence", purpose: "Evidence packs and the audit log" },
  { command: "/project", purpose: "Members, settings, and data controls" },
  { command: "/help", purpose: "Command help and examples" },
] as const;

/** Shortcuts shown under the box on an empty chat. */
export const ZOT_EMPTY_SHORTCUTS = [
  "/room",
  "/studio",
  "/run",
  "/work",
  "/approvals",
  "/usage",
] as const;

export function matchesFor(draft: string): string[] {
  if (!draft.startsWith("/")) return [];
  const token = draft.split(/\s/, 1)[0]!.toLowerCase();
  return ZOT_SLASH_COMMANDS.filter(({ command }) => command.startsWith(token)).map(
    ({ command }) => command,
  );
}
